export function selectCheckDate(cityName, date) {
  return {
    custom: {
      city_name: cityName,
      checkin_date: date.dateBegin,
      checkout_date: date.dateEnd,
    },
  };
}
